import { render, staticRenderFns } from "./allTopic.vue?vue&type=template&id=0f4eb607&scoped=true&"
import script from "./allTopic.vue?vue&type=script&lang=js&"
export * from "./allTopic.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newTopic/allInterviews.less?vue&type=style&index=0&id=0f4eb607&lang=less&scoped=true&"
import style1 from "./allTopic.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4eb607",
  null
  
)

component.options.__file = "allTopic.vue"
export default component.exports